import { FC, PropsWithChildren } from 'react';

import * as Styles from './message-container.styles';

export const MessageContainer: FC<PropsWithChildren> = ({ children }) => (
  <Styles.Container>
    <Styles.InnerContainer>{children}</Styles.InnerContainer>
  </Styles.Container>
);
